module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzMCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjU4MTQgMEM5LjExOTg1IDQuNTM3ODMgNS42OTY0NyA0Ljc1IDAgNC43NVYyMy4wMTM4QzAgMzAuMzAxOCA1LjE4OTM2IDMyLjIwMzQgMTQuNTgxNCAzOEMyMy45NzM0IDMyLjIwMzQgMjkuMTYyOCAzMC4zMDE4IDI5LjE2MjggMjMuMDEzOFY0Ljc1QzIzLjQ2NjMgNC43NSAyMC4wNDI5IDQuNTM3ODMgMTQuNTgxNCAwWiIgZmlsbD0iI0YxREI0QiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/shield.svg
// module id = 9v9c
// module chunks = 31